import { AppRouteProps } from "@bsm/component";
import { ScholarityListContainer } from "./container/ScholarityListContainer";
import { ScholarityCreateRoute } from "./views/create/ScholarityCreateRoute";
import { ScholarityDetailsRoute } from "./views/details/ScholarityDetailsRoute";

export const ScholarityListRoutes: Array<AppRouteProps> = [
    {
        path: 'scholarity',
        element: <ScholarityListContainer />,
        children: [
            ...ScholarityCreateRoute,
            ...ScholarityDetailsRoute
        ]
    }
]